<template>
  <div>
    <demandeEntete
      :demandeur="demandeur"
      :typeDemande="typeDemande"
      :codeTypeDemande="codeTypeDemande"
      :dateCreation="dateCreation"
      :commentaire="commentaire"
      :complements="complements"
      :motifRefus="motifRefus"
    />

    <v-card flat v-if="modeCreationExNihilo">
      <v-list-item>
        <v-list-item-content two-line class="pt-0">
          <v-list-item-title class="headline"
            >Personnes physiques existantes</v-list-item-title
          >
          <v-list-item-subtitle
            >Veuillez sélectionner la personne physique de
            rattachement</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="pt-0">
        <v-radio-group
          v-model="idHomonyme"
          dense
          :disabled="this.control.terminer"
        >
          <v-simple-table dense>
            <thead>
              <tr>
                <td colspan="3">
                  <v-radio
                    label="Créer une nouvelle personne physique"
                    :value="-1"
                  />
                </td>
              </tr>
              <tr>
                <th scope="col">N°</th>
                <th scope="col">Nom</th>
                <th scope="col">Prénom</th>
                <th scope="col">Mail</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(h, i) in homonymes"
                :key="`homonyme${i}`"
                @click="idHomonyme = h.id"
              >
                <td><v-radio :label="`${h.id}`" :value="h.id" /></td>
                <td>{{ h.nom }}</td>
                <td>{{ h.prenoms }}</td>
                <td>{{ h.mailPrincipal }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="this.idDemandePersonneMorale != null"
          text
          @click="lienDemande()"
          class="accent"
        >
          Lié à la demande de création de personne morale
          {{ this.idDemandePersonneMorale }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <viewPersonnePhysique
      ref="view"
      :idContact="0"
      :donneesConfidentiellesVisibles="donneesConfidentiellesVisibles"
      :enums="enums"
      :form="form"
      :control="control"
      :analyseDiff="analyseDiff"
      ajoutContactImpossible
      @annulerSuppression="annulerSuppression($event)"
      :pphReadonly="pphReadonly"
    />

    <entiteModificationModal />
    <demandeAction />
  </div>
</template>
<script>
import ViewPersonnePhysique from '@/view/personnephysique/ViewPersonnePhysique';
import EditeurDemande from '@/plugins/mixins/EditeurDemande';
import { routeEnter } from '@/utils/entite';
import toasted from '@/utils/toasted';
import DemandeEntete from '@/components/workflow/DemandeEntete';
import DemandeAction from '@/components/workflow/DemandeAction';
import { getInternational } from '@/components/telephone/telephoneUtil';
import { nettoyageTelephone } from '@/view/personnephysique/personnephysiqueUtils';

export default {
  components: {
    viewPersonnePhysique: ViewPersonnePhysique,
    demandeEntete: DemandeEntete,
    demandeAction: DemandeAction,
  },
  mixins: [EditeurDemande],
  beforeRouteEnter: routeEnter(withId => {
    withId(
      id => `workflow/demande/${id}`,
      (vm, body) => vm.initForm(body),
    );
  }),
  data() {
    return {
      // Configuration de l'IHM
      control: {
        readonly: true,
        enDemandeModification: false,
      },
      motifRefus: null,
      isIssueInscription: false,
      enums: {
        civilites: [],
        fonctions: [],
        typesContact: [],
        typesAccesAgil: [],
        typesAcces: [],
        typesLait: [],
        personnesMorales: [],
      },
      donneesConfidentiellesVisibles: false,
      homonymes: null,
      idHomonyme: -1,
      idDemandePersonneMorale: null,
      form: {
        id: null,
        nom: null,
        prenoms: null,
        civilite: {
          id: null,
          libelle: null,
        },
        telephone: null,
        confidentialiteTelephone: null,
        smsAccepte: null,
        mailPrincipal: null,
        confidentialiteMail: null,
        contacts: [],
        accesAgil: null,
        acces: null,

        //RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },
    };
  },

  computed: {
    pphReadonly() {
      if (this.modeCreationExNihilo) {
        return this.idHomonyme >= 0;
      }

      // s'il n'y a pas d'id de contact et qu'il y a un unique contact c'est une demande de rajoute de contact
      const contacts = this.form.contacts;
      return contacts.length == 1 && !contacts[0].id;
    },
    modeCreationExNihilo() {
      return (
        this.$auth.hasRole('PRIV_TRAITEMENT_DEMANDE_PERSONNE_PHYSIQUE') &&
        !!this.homonymes
      );
    },
  },

  methods: {
    initForm(data) {
      this.initEditeurDemande(data);

      //injection du droit d'edition
      this.control.edition = 'AUCUN';
      this.homonymes = data.homonymes;
      this.idDemandePersonneMorale = data.idDemandePersonneMorale;
      this.idHomonyme = -1;
      this.control.complementsPossible = !data.issueInscription;

      const loaded = data.objet;
      this.form.dateCreation = loaded.dateCreation;
      this.form.chargeCreation = loaded.chargeCreation;
      this.form.dateModification = loaded.dateModification;
      this.form.demandeurCreation = loaded.demandeurCreation;
      this.form.chargeModification = loaded.chargeModification;

      this.form.identifiant = loaded.identifiant;
      this.form.nom = loaded.nom;
      this.form.prenoms = loaded.prenoms;
      this.form.civilite.id = loaded.civilite.id;
      this.form.civilite.libelle = loaded.civilite.libelle;
      this.form.telephone = getInternational(loaded.telephone);
      this.form.confidentialiteTelephone = loaded.confidentialiteTelephone;
      this.form.smsAccepte = loaded.smsAccepte;
      this.form.mailPrincipal = loaded.mailPrincipal;
      this.form.confidentialiteMail = loaded.confidentialiteMail;
      this.form.contacts = loaded.contacts.map(c => {
        c.invalid = 0;
        return c;
      });
      this.form.accesAgil = [...loaded.accesAgil];
      this.form.acces = [...loaded.acces];

      this.donneesConfidentiellesVisibles =
        loaded.donneesConfidentiellesVisibles;

      if (data.enums) {
        this.initEnums(data.enums);
      }

      this.__initEdition();
    },

    initEnums(body) {
      const enums = this.enums;
      enums.civilites = body.civilites;
      enums.fonctions = body.fonctions;
      enums.typesContact = body.typesContact;
      enums.typesAccesAgil = body.typesAccesAgil;
      enums.typesLait = body.typesLait;
      enums.typesAcces = body.typesAcces;

      enums.personnesMorales = body.personnesMorales || [];
    },

    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },

    lienDemande() {
      this.$router.push({
        name: 'workflow/demande/personnemorale/detail',
        params: {
          id: this.idDemandePersonneMorale,
        },
      });
    },

    validerDemande() {
      const id = this.idDemande;
      const pph = nettoyageTelephone(this.form);

      var data = null;
      var url = null;

      if (this.idDemandePersonneMorale != null) {
        this.control.dialogValider = false;
        toasted.error('demande.status.PMFirst');
        return;
      }

      if ('modification' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        url = `workflow/demande/modification/${id}/personne-physique/valider`;
        // filtre en supprimant tous les champs supprimés
        data = pph;
        data.accesAgil = data.accesAgil.filter(
          this.creationFiltreSupprimes('accesAgil'),
        );
        data.acces = data.acces.filter(this.creationFiltreSupprimes('acces'));

        const cnt = { ...data.contacts[0] };
        cnt.telephones = cnt.telephones.filter(
          this.creationFiltreSupprimes('contacts[0].telephones', true),
        );
        cnt.adresses = cnt.adresses.filter(
          this.creationFiltreSupprimes('contacts[0].adresses', true),
        );
        cnt.typeLait = cnt.typeLait.filter(
          this.creationFiltreSupprimes('contacts[0].typeLait'),
        );
        cnt.instances = cnt.instances.filter(
          this.creationFiltreSupprimes('contacts[0].instances', true),
        );
        data.contacts[0] = cnt;
      } else if ('suppression' === this.codeTypeDemande) {
        url = `workflow/demande/suppression/${id}/personne-physique/valider`;
        data = pph;
      } else if ('creation' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        if (this.modeCreationExNihilo) {
          //2 urls possibles, soit on utiliser un homonyme (donc on passe juste le contact) soit on creer tout
          if (this.idHomonyme >= 0) {
            url = `workflow/demande/creation/${id}/personne-physique/${this.idHomonyme}/valider`;
            data = pph.contacts[0];
          } else {
            url = `workflow/demande/creation/${id}/personne-physique/valider`;
            data = pph;
          }
        } else {
          url = `workflow/demande/creation/${id}/contact/valider`;
          data = this.form.contacts[0];
        }
      }

      this.control.validerDemande = true;
      this.$api(url)
        .post(data)
        .then(() => {
          toasted.info('demande.status.valide');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .catch(errors => {
          this.control.dialogValider = false;
          this.errorsHandler(errors);
        })
        .finally(() => (this.control.validerDemande = false));
    },
  },
};
</script>
